import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { SpProjectListComponent } from './sp-project-list/sp-project-list.component';
import { SpProjectRoutingModule } from './sp-project-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import {SpLayoutModule} from '../sp-layout/sp-layout.module';
import { MatInputModule } from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { OrderByPipe } from '../../pipes/order-by.pipe';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {CarouselModule} from 'primeng/carousel';
import {ResizableModule} from 'angular-resizable-element';
import {GridsterModule} from 'angular-gridster2';

@NgModule({
  declarations: [
    SpProjectListComponent,
    OrderByPipe
  ],
  exports: [
    OrderByPipe,
  ],
  imports: [
    CommonModule,
    SpProjectRoutingModule,
    MatIconModule,
    SpLayoutModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    DragDropModule,
    MatSelectModule,
    CarouselModule,
    MatStepperModule,
    ReactiveFormsModule,
    ResizableModule,
    MatCheckboxModule,
    GridsterModule,
    MatExpansionModule
  ]
})
export class SpProjectModule {}
